import { useState, useEffect, useRef } from "react"
import { DateTime } from "luxon"

function useInterval(callback, delay) {
  const savedCallback = useRef()

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

const TimeZones = () => {
  const [allTimes, setAllTimes] = useState({
    berlin: { hours: "", minutes: "" },
    la: { hours: "", minutes: "" },
  })

  useInterval(() => {
    setTimes()
  }, 1000)

  useEffect(() => {
    window.DateTime = DateTime

    setTimes()
  }, [])

  const setTimes = () => {
    const berlinTargetDate = DateTime.now().setZone("Europe/Berlin")

    const laTargetDate = DateTime.now().setZone("America/Los_Angeles")

    const minutes = berlinTargetDate.minute
    const minutesInString = minutes > 9 ? minutes : `0${minutes}`

    const berlinHours =
      berlinTargetDate.hour > 9
        ? berlinTargetDate.hour
        : `0${berlinTargetDate.hour}`

    const laHours =
      laTargetDate.hour > 9 ? laTargetDate.hour : `0${laTargetDate.hour}`

    let berlinTime = { hours: berlinHours, minutes: minutesInString }
    let laTime = { hours: laHours, minutes: minutesInString }

    setAllTimes({ berlin: berlinTime, la: laTime })
  }

  return allTimes
}

export default TimeZones
